export enum PlatformEnum {
  TikTok = 'tiktok',
  Instagram = 'instagram',
  Reddit = 'reddit',
}
